import Box from "@material-ui/core/Box";
import React, {useEffect, useState} from "react";
import Card from "@material-ui/core/Card";
import {useTranslation} from "react-i18next";

import CardMedia from "@material-ui/core/CardMedia";
import {getDate, getRandomInt} from "../../utils";
import ElementsInLine from "../miscelaneous/ElementsInLine";
import {useCardStyles} from "../../styles/card";
import GenericLogoLabel from "../miscelaneous/genericLogoLabel";
import useTheme from "@material-ui/core/styles/useTheme";

export default function ReviewCard(props) {

    const {review, footer, logo, profilePic} = props
    const classes = useCardStyles();
    const {t} = useTranslation()
    const [imageCheck, setImageCheck] = useState(false);
    const reviewDate = review.date ? getDate(review.date, t) : ""
    const theme = useTheme();

    useEffect(() => {

        if (review.profile_picture.includes('https://recensioni-io-static-folder.s3.eu-central-1.amazonaws.com/public_climbo/images/user')) {
            return
        }

        fetch(review.profile_picture, {
            method: "GET"
        }).then(response => {
            if (response.status === 200) {
                setImageCheck(true)
            }
        });
    })


    return <Card className={classes.ReviewCardPopUp}>
        <Box
            display={'flex'}
            flexDirection={'column'}
            height={'100%'}
            p={3}
        >

            <Box display={'flex'}
                 alignItems={'start'}>
                <Box mb={2} display={'flex'} alignItems={'center'}>
                    <img className={"providerLogoPopUp"}
                         alt="business logo"
                         style={{cursor: "pointer", marginRight: 10}}
                         onClick={() => {
                             window.open(review.url, "_blank")
                         }}
                         src={`https://recensioni-io-static-folder.s3.eu-central-1.amazonaws.com/public_climbo/images/integrations/${review.source}.png`}/>
                    <span style={{textTransform:'capitalize'}}>{review.source}</span>
                </Box>

                <Box ml={"auto"}>
                     <span
                         style={{lineHeight: "150%"}}>
                        {reviewDate}
                </span>
                </Box>
            </Box>

            <ElementsInLine
                spaced={false} start={true}
                elements={[profilePic ?
                    <CardMedia style={{
                        width: 90,
                        height: 90,
                        marginBottom: '8px',
                        marginRight: '20px',
                        borderRadius: '100%'
                    }}
                               component="img"
                               alt="profile picture"
                               image={imageCheck ? review.profile_picture
                                   : 'https://recensioni-io-static-folder.s3.eu-central-1.amazonaws.com/public_climbo/images/no_image.png'}/>
                    : null,
                    <Box>
                        <Box>
                            {[...Array(review.rating_value).keys()].map((v, i) =>
                                <img
                                    src={`https://recensioni-io-static-folder.s3.eu-central-1.amazonaws.com/public_climbo/images/social/star.png`}
                                    alt="star"
                                    key={i}
                                    style={{width: 16, paddingRight: "4px"}}/>)}
                        </Box>
                        <Box className={"line-clamp"} mb={1} height={'100%'}
                             overflow={'auto'}>{review.review_text}</Box>
                        <Box>
                            <span style={{color: theme.card.color, lineHeight: "150%", opacity: 0.7}}>{review.name}
                            </span>
                        </Box>
                    </Box>]}/>
            <Box pt={1}>
                {footer ? <GenericLogoLabel text={t("W_VERIFIED_F")}
                                            link={"https://www.climbo.com"}
                                            logo={logo}/> : null}
            </Box>
        </Box>
    </Card>

}